import { ChangeDetectionStrategy, Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { UserService } from '@shared/core';
import { AuthorizedUser } from '@shared/core/types';
import { PageCabinetService } from './page-cabinet.service';
import { ActivatedRoute, ActivationEnd, Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { filter, map, startWith } from 'rxjs/operators';
import { DecorateUntilDestroy, takeUntilDestroyed } from '@skyeng/libs/shared/rxjs';

interface LayoutConfig {
  readonly isFullScreen: boolean;
  readonly withPadding: boolean;
}

@DecorateUntilDestroy()
@Component({
  templateUrl: './page-cabinet.component.html',
  styleUrls: ['./page-cabinet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageCabinetComponent implements OnInit {
  @ViewChild('bottomTemplate', { read: ViewContainerRef, static: true }) bottomTemplate: ViewContainerRef;

  user: AuthorizedUser;
  uiLanguage$ = this.translocoService.langChanges$.pipe(startWith(this.translocoService.getActiveLang()));
  isFullScreen = false;
  withPadding = false;

  constructor(
    private layoutService: PageCabinetService,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private translocoService: TranslocoService,
    private router: Router,
  ) {
    this.subscribeToNavigationEventsToResolveData();
  }

  ngOnInit(): void {
    this.user = this.userService.getUser();

    this.layoutService.setLayoutElements({
      bottom: this.bottomTemplate,
    });
  }

  private subscribeToNavigationEventsToResolveData(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof ActivationEnd && event.snapshot.children.length === 0),
        map((event: ActivationEnd) => event.snapshot.data.layoutConfig || {}),
        takeUntilDestroyed(this),
      )
      .subscribe((layoutConfig: LayoutConfig) => {
        this.isFullScreen = layoutConfig?.isFullScreen;
        this.withPadding = layoutConfig?.withPadding;
      });
  }
}
